(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/physical-tickets/components/physical-tickets-form/components/customer-information/customer-information.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/physical-tickets/components/physical-tickets-form/components/customer-information/customer-information.js');
"use strict";

const UPDATE_CUSTOMERINFO_FORM = svs.ticket_partner.physicalTickets.actions.UPDATE_CUSTOMERINFO_FORM;
const _svs$ticket_partner$p = svs.ticket_partner.physicalTickets.constants.FORMS,
  DELIVERY_INFO = _svs$ticket_partner$p.DELIVERY_INFO,
  COMPANY_SECTION_HEADER = _svs$ticket_partner$p.COMPANY_SECTION_HEADER,
  CONTACT_SECTTION_HEADER = _svs$ticket_partner$p.CONTACT_SECTTION_HEADER,
  BILLING_SECTION_HEADER = _svs$ticket_partner$p.BILLING_SECTION_HEADER;
const _svs$ticket_partner$p2 = svs.ticket_partner.physicalTickets.physicalTicketsForm.customerInformation.components,
  DeliverLatestInput = _svs$ticket_partner$p2.DeliverLatestInput,
  OtherAdressInput = _svs$ticket_partner$p2.OtherAdressInput,
  MessageInput = _svs$ticket_partner$p2.MessageInput;
const _svs$ticket_partner$s = svs.ticket_partner.sharedComponents.input,
  AdressInput = _svs$ticket_partner$s.AdressInput,
  EmailInput = _svs$ticket_partner$s.EmailInput,
  ContactInput = _svs$ticket_partner$s.ContactInput,
  CompanyNameInput = _svs$ticket_partner$s.CompanyNameInput,
  OrgNrInput = _svs$ticket_partner$s.OrgNrInput,
  CityInput = _svs$ticket_partner$s.CityInput,
  PhoneNrInput = _svs$ticket_partner$s.PhoneNrInput,
  ZipCodeInput = _svs$ticket_partner$s.ZipCodeInput;
const _svs$ui$ReactGrid = svs.ui.ReactGrid,
  Grid = _svs$ui$ReactGrid.Grid,
  GridCol = _svs$ui$ReactGrid.GridCol,
  GridRow = _svs$ui$ReactGrid.GridRow;
const CustomerInformation = _ref => {
  let dispatch = _ref.dispatch,
    state = _ref.state;
  const handleInputChange = _ref2 => {
    let _ref2$target = _ref2.target,
      value = _ref2$target.value,
      id = _ref2$target.id;
    dispatch({
      type: UPDATE_CUSTOMERINFO_FORM,
      payload: {
        field: id,
        value
      }
    });
  };
  return React.createElement(Grid, null, React.createElement("h2", null, COMPANY_SECTION_HEADER), React.createElement(GridRow, {
    gutter: {
      y: 0
    }
  }, React.createElement(GridCol, {
    am: 8,
    sm: 12
  }, React.createElement(CompanyNameInput, {
    handleChange: handleInputChange,
    state: state
  })), React.createElement(GridCol, {
    am: 4,
    sm: 12
  }, React.createElement(OrgNrInput, {
    handleChange: handleInputChange,
    state: state
  }))), React.createElement("h2", null, CONTACT_SECTTION_HEADER), React.createElement(GridRow, {
    gutter: {
      y: 0
    }
  }, React.createElement(GridCol, {
    am: 5,
    sm: 12
  }, React.createElement(ContactInput, {
    handleChange: handleInputChange,
    state: state
  })), React.createElement(GridCol, {
    am: 4,
    sm: 12
  }, React.createElement(EmailInput, {
    handleChange: handleInputChange,
    state: state
  })), React.createElement(GridCol, {
    am: 3,
    sm: 12
  }, React.createElement(PhoneNrInput, {
    handleChange: handleInputChange,
    state: state
  }))), React.createElement("h2", null, BILLING_SECTION_HEADER), React.createElement(GridRow, {
    gutter: {
      y: 0
    }
  }, React.createElement(GridCol, {
    am: 5,
    sm: 12
  }, React.createElement(AdressInput, {
    handleChange: handleInputChange,
    state: state
  })), React.createElement(GridCol, {
    am: 3,
    sm: 12
  }, React.createElement(ZipCodeInput, {
    handleChange: handleInputChange,
    state: state
  })), React.createElement(GridCol, {
    am: 4,
    sm: 12
  }, React.createElement(CityInput, {
    handleChange: handleInputChange,
    state: state
  }))), React.createElement(GridRow, null, React.createElement(GridCol, {
    am: 12,
    md: 6,
    sm: 12
  }, React.createElement(DeliverLatestInput, {
    handleChange: handleInputChange,
    state: state
  }), React.createElement("div", {
    className: "margin-top-1"
  }, React.createElement("p", null, DELIVERY_INFO))), React.createElement(GridCol, {
    am: 12,
    md: 6,
    sm: 12
  }, React.createElement(OtherAdressInput, {
    handleChange: handleInputChange,
    state: state
  }))), React.createElement(GridRow, null, React.createElement(GridCol, {
    am: 12,
    sm: 12
  }, React.createElement(MessageInput, {
    handleChange: handleInputChange,
    state: state
  }))));
};
svs.ticket_partner.physicalTickets.physicalTicketsForm.customerInformation.CustomerInformation = CustomerInformation;

 })(window);